import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import WarehouseQuoteStorageForm from './forms/WareHouseStorageForms/WareHouseStorageForm';
import useWarehouseStorageService from '../../../../../app/services/hooks/useWareHouseQuoteStorageService';
import { WarehouseQuoteStorageDataForm } from '../../../../../app/models/WareHouseQuoteStorage';
import { Depot } from '../../../../../app/models/Depot';
import { AppContext } from '../../../../../contexts/AppContext';
import useReactConfirmAlert from '../../../../../hooks/useReactConfirmAlert';

interface Props {
  quoteId: number;
  onSaved: () => void;
  onCancel: () => void;
}

const WarehouseQuoteStorageCreate: React.FC<Props> = ({ quoteId, onSaved, onCancel }) => {
  const {
    createWarehouseQuoteStorage,
    storeWarehouseQuoteStorage,
    fetchingCreateWarehouseQuoteStorage,
    fetchingStoreWarehouseQuoteStorage
  } = useWarehouseStorageService();
    const { hideLoading } = useContext(AppContext);

  const [form, setForm] = useState<WarehouseQuoteStorageDataForm>({
    quote_id: quoteId,
    free_days: 0,
    depot_id: 0
  });

  const [depots, setDepots] = useState<Depot[]>([]);
  const [errorFields, setErrorFields] = useState<any>();

  const create = () => {
    createWarehouseQuoteStorage(quoteId, {
      onSuccess: (response: ServiceResponse) => {
        setDepots(response.data.depots);
      },
      onError: (response: ServiceResponse) => {
        toast.error('Error al cargar datos de almacenamiento: ' + response.message);
        onCancel();
      },

    });
  };

  useEffect(() => {
    create();
  }, []);

  const store = () => {
    storeWarehouseQuoteStorage(form, {
      onSuccess: (response: ServiceResponse) => {
          if (hideLoading) hideLoading();

          useReactConfirmAlert().successAlert({
              title: 'Éxito',
              message: response.message
          });
          toast.success(response.message, {
              autoClose: 2500
          });
          if (onSaved) onSaved();
      },
      onError: (response: ServiceResponse) => {
          if (hideLoading) hideLoading();
          useReactConfirmAlert().errorAlert({
              title: 'Error',
              message: response.message
          });
      },

      onFieldError: (errorFields: ServiceResponse) => {
          if (hideLoading) hideLoading();

          setErrorFields(errorFields.data);
      }


    });
  };

  if (fetchingCreateWarehouseQuoteStorage) {
    return <p>Cargando datos de almacenamiento…</p>;
  }

  return (
    <>
      <WarehouseQuoteStorageForm
        warehouseStorageform={form}
        setWarehouseStorageform={setForm}
        depots={depots}
        errorFields={errorFields}
      />
      <hr />
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={onCancel} locked={fetchingStoreWarehouseQuoteStorage} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm 
            callbackSave={store} 
            locked={fetchingStoreWarehouseQuoteStorage} 
          />
        </div>
      </div>
    </>
  );
};

export default WarehouseQuoteStorageCreate;
